import { useState } from "react";
import { Loader2, Trash } from "lucide-react";
import type { DocumentRecord } from "@shyne/shared/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

type DocumentDeleteButtonProps = { document: DocumentRecord; deleting: boolean; onDelete: (id: string) => Promise<void> };

export function DocumentDeleteButton({ document, deleting, onDelete }: DocumentDeleteButtonProps) {
  const [confirming, setConfirming] = useState(false);

  const deleteConfirmed = async () => {
    await onDelete(document.id);
    setConfirming(false);
  };

  return (
    <Dialog open={confirming} onOpenChange={setConfirming}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" aria-label={`Delete ${document.filename}`} disabled={deleting} className="text-destructive hover:text-destructive">
          {deleting ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash className="h-4 w-4" />}
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove Document?</DialogTitle>
        </DialogHeader>
        <p className="pt-2 text-sm text-muted-foreground">Are you sure you want to delete "{document.filename}"? This action cannot be undone.</p>
        <DialogFooter className="pt-4">
          <Button variant="outline" onClick={() => setConfirming(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={deleteConfirmed} disabled={deleting}>
            {deleting && <Loader2 className="h-4 w-4 animate-spin" />}
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
